import { useLocation, useHistory } from 'react-router-dom';
import { useIsExternalUser } from './useIsExternalUser';

export const useQueryParams = () => {
  const params = new URLSearchParams(window ? window.location.search : {});
  return new Proxy(params, {
    get(target, prop) {
      return target.get(prop);
    },
  });
};

export const useNavigate = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const pathWithQuery = search ? `${pathname}${search}` : pathname;

  const isExternalUser = useIsExternalUser();

  const queryParams = useQueryParams();
  const skipRedirect = ['/', '/login'];

  const goToHome = () => {
    const { redirect } = queryParams;
    const home = '/dashboard';

    if (redirect) {
      // Fully decode the redirect URL
      let decoded = redirect;
      let prev = '';
      while (decoded !== prev) {
        prev = decoded;
        try {
          decoded = decodeURIComponent(decoded);
        } catch {
          break;
        }
      }
      // If it contains /login, split and get the final redirect
      if (decoded.includes('/login')) {
        const parts = decoded.split('/login');
        const lastPart = parts[parts.length - 1];
        // Extract everything after 'redirect=' to preserve query params
        const redirectIndex = lastPart.indexOf('redirect=');
        if (redirectIndex !== -1) {
          const finalPath = lastPart.substring(
            redirectIndex + 'redirect='.length
          );
          history.push(decodeURIComponent(finalPath));
          return;
        }
      }
      history.push(decoded);
      return;
    }
    // refresh the page to initiate onboarding.
    // history.push(home);
    if (isExternalUser) {
      history.push('/projects');
      return;
    }
    window.open(`${window.location.origin + home}`, '_self');
  };

  const goToLogin = () => {
    const login = '/login';
    if (skipRedirect.includes(pathWithQuery)) {
      history.push(login);
      return;
    }
    history.push(`${login}?redirect=${encodeURIComponent(pathWithQuery)}`);
  };

  return {
    goToLogin,
    goToHome,
  };
};
